import { ActionSheetIOS, Platform } from 'react-native';
import { Alert } from '../components/alert';

// 9.35.4 · D-830 — one confirmation for an action that cannot be undone.
//
// iOS: an action sheet with a red button, as Apple's HIG asks for a choice
// that follows something the person deliberately started (Photos does the
// same for Delete). Android: the system alert. Web: the app's own dialog
// (components/alert.ts), or the browser's confirm before it is mounted.
export type DestructiveConfirmation = {
  title: string;
  message?: string;
  confirm: string;
  cancel: string;
};

export function confirmDestructive(copy: DestructiveConfirmation, onConfirm: () => void): void {
  if (Platform.OS === 'ios') {
    ActionSheetIOS.showActionSheetWithOptions(
      {
        title: copy.title,
        message: copy.message,
        options: [copy.confirm, copy.cancel],
        destructiveButtonIndex: 0,
        cancelButtonIndex: 1,
      },
      (index) => { if (index === 0) onConfirm(); },
    );
    return;
  }
  Alert.alert(copy.title, copy.message, [
    { text: copy.cancel, style: 'cancel' },
    { text: copy.confirm, style: 'destructive', onPress: onConfirm },
  ]);
}
